import usePortfolioBatchEquipmentIntelligenceMutation from "ApiLayer/Chatbot/mutatePortfolioBatchEquipmentIntelligence";
import useDownloadBulkEquipmentSurveyCsvMutation from "ApiLayer/Equipment/downloadBulkEquipmentSurveyCsv";
import useDownloadEquipmentExportCsvMutation from "ApiLayer/Equipment/downloadEquipmentExportCsv";
import useSubmitBulkEquipmentSurveyCsvMutation from "ApiLayer/Equipment/submitBulkEquipmentSurveyCsv";
import { Button } from "components/atoms/Button";
import BulkEquipmentUploadModal from "components/organisms/Modals/BulkEquipmentUploadModal/BulkEquipmentUploadModal";
import { useActiveCustomerAccount } from "hooks/useActiveCustomerAccount";
import { useBuildingModelsTableQuery } from "queries/useBuildingModelsTable";
import { useState } from "react";
import useBulkEquipmentUploadState from "recoilStore/useBulkEquipmentUploadState";
import styles from "./Sandbox.module.scss";

function SandboxPortfolioPage() {
    const { data: buildingModels, isLoading: isLoadingBuildings } = useBuildingModelsTableQuery();
    const buildingCount = buildingModels?.length ?? 0;

    const { user } = useActiveCustomerAccount();
    const customerAccountUid = user?.activeOrganization?.customerAccountUid;

    const { mutate: startBatchEquipmentIntelligence, isLoading: batchEquipmentIsLoading } =
        usePortfolioBatchEquipmentIntelligenceMutation();

    const { mutate: downloadEquipmentExport, isLoading: isDownloadingEquipmentExport } =
        useDownloadEquipmentExportCsvMutation();

    const [bulkUploadModalIsOpen, setBulkUploadModalIsOpen] = useState(false);
    const { setState: setBulkUploadState } = useBulkEquipmentUploadState();
    const { mutate: submitBulkEquipmentSurvey, isLoading: isBulkUploading } = useSubmitBulkEquipmentSurveyCsvMutation({
        onSuccess: (data) => {
            setBulkUploadState({
                showBanner: true,
                batchId: data.batch_id,
                total: data.queued,
                completed: 0,
                failed: 0,
                status: "processing",
            });
        },
    });
    const { mutate: downloadBulkEquipmentSurvey, isLoading: isDownloadingTemplate } =
        useDownloadBulkEquipmentSurveyCsvMutation();

    return (
        <div className={styles["sandbox-container"]}>
            <div className={styles["sandbox-header"]}>
                <h1>🧪 Portfolio Sandbox</h1>
            </div>
            <div className={styles["sandbox-grid"]}>
                <div className={styles["sandbox-item"]}>
                    <h3>Equipment Intelligence</h3>
                    <p>
                        Run the equipment topology agent for {buildingCount} buildings and receive the results as a CSV.
                    </p>
                    <Button
                        type="secondary"
                        onClick={() => startBatchEquipmentIntelligence()}
                        disabled={isLoadingBuildings || batchEquipmentIsLoading}
                    >
                        Generate
                    </Button>
                </div>
                <div className={styles["sandbox-item"]}>
                    <h3>Equipment Export</h3>
                    <p>Download the current org's equipment inventory as a CSV.</p>
                    <Button
                        type="secondary"
                        onClick={() => downloadEquipmentExport()}
                        disabled={!customerAccountUid || isDownloadingEquipmentExport}
                    >
                        Download CSV
                    </Button>
                </div>
                <div className={styles["sandbox-item"]}>
                    <h3>Bulk Equipment Upload</h3>
                    <p>
                        Upload equipment surveys for multiple buildings at once with a CSV. <br /> <br />
                        The CSV requires a specific format. Use the download equipment CSV below to get the correct
                        format, edit the values, then upload.
                    </p>
                    <Button
                        type="secondary"
                        onClick={() => downloadBulkEquipmentSurvey()}
                        disabled={isDownloadingTemplate}
                    >
                        Download Equipment CSV for upload
                    </Button>
                    <Button type="secondary" onClick={() => setBulkUploadModalIsOpen(true)} disabled={isBulkUploading}>
                        Upload CSV
                    </Button>
                </div>
            </div>
            <BulkEquipmentUploadModal
                modalIsOpen={bulkUploadModalIsOpen}
                onCancel={() => setBulkUploadModalIsOpen(false)}
                submitBulkEquipmentSurvey={(file) => submitBulkEquipmentSurvey(file)}
            />
        </div>
    );
}

export default SandboxPortfolioPage;
